<app-command [command]="update$" (success)="saved()">
  <app-details-modal
    [title]="title"
    [saveLabel]="saveLabel"
    [form]="formGroup"
    (cancel)="cancel()"
    (save)="save()">
    <app-details-content>
      <ng-container *appLoad="let data of load$; trackingName: 'company-details'">
        <form [formGroup]="formGroup">
          <ng-container>
            <!-- details -->
            <section class="mb-md">
              <h4>Details</h4>

              <div class="row">
                <div class="col-12 col-sm-6 col-lg-6">
                  <lds-text-input
                    formControlName="name"
                    label="Name"
                    placeholder="name of company"
                    [isRequired]="
                      data.schema.company.name | standardRequirement
                    "
                    [maxlength]="160"
                    [validations]="{
                      required: 'Name is required'
                    }">
                  </lds-text-input>
                </div>
                <div class="col-12 col-sm-6 col-lg-6">
                  <lds-text-input
                    formControlName="tradingName"
                    label="Trading name"
                    placeholder="trading name of company"
                    [isRequired]="
                      data.schema.company.tradingName | standardRequirement
                    "
                    [maxlength]="150">
                  </lds-text-input>
                </div>
                <div class="col-12 col-sm-6 col-lg-6">
                  <lds-select
                    formControlName="businessNature"
                    name="businessNature"
                    label="Business nature"
                    [isRequired]="
                      data.schema.company.businessNature | standardRequirement
                    "
                    [options]="
                      data.schema.company.businessNature.options
                        | ldsSelectOption
                    ">
                  </lds-select>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <business-number
                    formControlName="businessNumber"
                    [isRequired]="
                      data.schema.company.businessNumber | standardRequirement
                    "
                    [showHighlight]="
                      data.schema.company.businessNumber | standardRequirement
                    "></business-number>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <lds-date-input
                    formControlName="startDate"
                    name="startDate"
                    [label]="startDateLabel"
                    [isRequired]="
                      data.schema.company.startDate | standardRequirement
                    "
                    [validations]="{
                      date: 'Must be a valid date',
                      dateBefore: 'Must be a date in the past'
                    }">
                  </lds-date-input>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <company-number
                    formControlName="companyNumber"
                    [isRequired]="
                      data.schema.company.companyNumber | standardRequirement
                    "
                    [showHighlight]="
                      data.schema.company.companyNumber | standardRequirement
                    "></company-number>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <lds-date-input
                    formControlName="gstRegistrationDate"
                    name="gstRegistrationDate"
                    label="GST registration"
                    [isRequired]="
                      data.schema.company.gstRegistrationDate
                        | standardRequirement
                    "
                    [validations]="{
                      date: 'Must be a valid date',
                      dateBefore: 'Must be a date in the past',
                      dateAfter: 'Must be a valid GST reg date'
                    }">
                  </lds-date-input>
                </div>
                <div class="col-12 col-sm-6 col-lg-6">
                  <lds-text-input
                    formControlName="accountantName"
                    name="accountantName"
                    label="Accountant name"
                    [isRequired]="
                      data.schema.company.accountantName | standardRequirement
                    "
                    placeholder="accountant name"
                    [maxlength]="160">
                  </lds-text-input>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <spark-shared-contact-number
                    formControlName="accountantPhone"
                    label="Accountant number"
                    [isRequired]="
                      data.schema.company.accountantPhone | standardRequirement
                    "
                    [validations]="{
                      required: 'Accountant number is required',
                      contactNumberValidator:
                        'Please enter a valid contact number'
                    }">
                  </spark-shared-contact-number>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <lds-select
                    formControlName="status"
                    name="status"
                    label="Status"
                    [isRequired]="
                      data.schema.company.status | standardRequirement
                    "
                    [options]="
                      data.schema.company.status.options | ldsSelectOption
                    "
                    [validations]="{
                      required: 'Status is required'
                    }">
                  </lds-select>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <lds-select
                    formControlName="contactType"
                    name="contactType"
                    label="Contact type"
                    [isRequired]="
                      data.schema.company.contactType | standardRequirement
                    "
                    [options]="
                      data.schema.company.contactType.options | ldsSelectOption
                    ">
                  </lds-select>
                </div>
              </div>
              <div
                class="row"
                *ngIf="
                  formGroup.controls.contactType.value | displayAffiliateId
                ">
                <div class="col-12 col-sm-6 col-lg-6">
                  <lds-text-input
                    formControlName="nmbAffiliateId"
                    label="Affiliate ID"
                    placeholder="Affiliate ID"
                    [isRequired]="
                      data.schema.company.nmbAffiliateId | standardRequirement
                    "
                    [maxlength]="100"
                    [validations]="{
                      required: 'Affiliate ID is required'
                    }">
                  </lds-text-input>
                </div>
              </div>
            </section>

            <!-- addresses -->
            <section class="mb-md">
              <h4>Address</h4>

              <div class="row">
                <div class="col">
                  <agp-shared-address
                    label="Address"
                    formControlName="address"
                    identifier="address"
                    [options]="addressOptions$ | async">
                  </agp-shared-address>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <agp-shared-address
                    label="Registered office"
                    formControlName="registeredOffice"
                    identifier="registered-office-address"
                    [options]="addressOptions$ | async">
                  </agp-shared-address>
                </div>
              </div>
            </section>
          </ng-container>

          <!-- directors -->
          <section class="mb-lg">
            <spark-contacts-company-directors
              formControlName="directors"
              [contacts]="data.content.contacts"
              [isRequired]="
                data.schema.company.directors | standardRequirement
              ">
            </spark-contacts-company-directors>
          </section>

          <!-- shareholders -->
          <section class="mb-lg">
            <spark-contacts-company-shareholders
              formControlName="shareholders"
              [contacts]="data.content.contacts"
              [isRequired]="data.schema.shareholders | standardRequirement">
            </spark-contacts-company-shareholders>
          </section>

          <section class="mb-lg" *ngIf="!(formGroup.controls.contactType.value | referrerArrangementHidden)">
            <spark-contacts-referrer-arrangement
              formControlName="referrerArrangement"
              [schema]="data.schema.company.referrerArrangement"
              [isDisabled]="formGroup.controls.nmbAffiliateId.value | referrerArrangementDisabled">
            </spark-contacts-referrer-arrangement>
          </section>

          <section class="mt-sm">
            <div class="tags-section">
              <h4>Tags</h4>
              <lds-card>
                <div class="tags-section__details">
                  <app-tag-input
                    [entityId]="isNewEntity ? '' : companyId"
                    [entityType]="tagEntityType"
                    [showLabel]="false"
                    [readonly]="false"
                    (tagsChanged)="onTagsChanged($event)">
                  </app-tag-input>
                </div>
              </lds-card>
            </div>
          </section>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>
